import { SearchableDropdownSelect } from '../web-components/searchable-dropdown-select';
import { closeDrawer } from './drawer-component';

export async function launchBreederSelectionModal(): Promise<string | null> {
  return new Promise((resolve) => {
    const handle = document.createElement('button');
    handle.setAttribute('data-drawer-trigger', 'true');
    handle.setAttribute('data-controls', 'drawer-breeder-selector');
    handle.setAttribute('aria-expanded', 'false');
    document.body.appendChild(handle);
    handle.click();

    window.addEventListener('breeder:selected', (event) => {
      if (event instanceof CustomEvent) {
        resolve(event.detail.breeder as string);
        handle.remove();
      }
    });

    window.addEventListener('breeder:denied', () => {
      resolve(null);
      handle.remove();
    });
  });
}

const updateTheDrawerMessage = (selections: string[]) => {
  const message = document.querySelector('.drawer__content__message');
  if (!message) {
    return;
  }

  if (selections.length > 0) {
    message.classList.remove('hidden');
    return;
  }

  message.classList.add('hidden');
};

const confirmBreederSelection = (selections: string[]) => {
  if (!selections.length) {
    return;
  }

  const breeder = selections[0];

  const event = new CustomEvent('breeder:selected', {
    detail: {
      breeder,
    },
  });

  window.dispatchEvent(event);
};

export const initBreederSelector = () => {
  const breederSelector =
    document.querySelector<SearchableDropdownSelect>('.breeder-selector');
  const drawer = document.querySelector('.drawer--breeder-selector');
  if (!drawer) {
    return;
  }

  const confirmButton = drawer.querySelector('.button-save-and-continue');
  const drawerCloseButtons = drawer.querySelectorAll('[data-drawer-close]');

  confirmButton?.addEventListener('click', (e) => {
    e.preventDefault();
    if (breederSelector && 'selected' in breederSelector) {
      confirmBreederSelection(breederSelector.selected);
      confirmButton.setAttribute('data-busy', 'true');
    }
  });

  document.addEventListener('cart-drawer:opened', () => {
    closeDrawer(drawer);

    confirmButton?.removeAttribute('data-busy');
    breederSelector?.clear();
    confirmButton?.setAttribute('disabled', 'true');
  });

  drawerCloseButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const event = new CustomEvent('breeder:denied', {
        detail: {
          breeder: null,
        },
      });

      window.dispatchEvent(event);
    });
  });

  const disableButton = (disabled = false) => {
    if (confirmButton instanceof HTMLButtonElement) {
      confirmButton.disabled = disabled;
    }
  };

  breederSelector?.addEventListener('change', (event) => {
    if (!(event instanceof CustomEvent)) {
      return;
    }

    updateTheDrawerMessage(event.detail.selected);

    disableButton(event.detail?.value.trim() === '');
  });
};
